import * as gqlTypes from "@hydrologiq/gql-experience/graphql"

const NON_HYDROGEN_KINDS = [gqlTypes.AssetKind.Battery, gqlTypes.AssetKind.Generator]

/**
 * Displays hydrogen level for an asset from asset_attribute (current_level_kg)
 */
function AssetHydrogenLevel(props: { asset: gqlTypes.Asset }) {
  const { asset } = props

  // Non-hydrogen assets always show n/a
  if (NON_HYDROGEN_KINDS.includes(asset.kind as gqlTypes.AssetKind)) {
    return "n/a"
  }

  // Format value to 2 decimal places
  const formatValue = (value: number) => value.toFixed(2)

  // Read from asset attribute (current_level_kg from view)
  const currentLevelKg = asset.current_level_kg

  if (currentLevelKg != null) {
    const level = Number(currentLevelKg)
    return isNaN(level) ? "n/a" : formatValue(level)
  }

  return "n/a"
}

export default AssetHydrogenLevel
